import { Features } from "@asosteam/asos-web-toggle-point-app";
import logWarning from "../../lib/logger";

const { decisionsContext, audienceContext, featuresProviderFactory } = Features;

const FeaturesProvider = featuresProviderFactory({
  appShortName: "plp",
  logWarning
});

export { decisionsContext, audienceContext, FeaturesProvider };
